import React from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Page from "../../components/Page";
import PreCibilQualification from "../../components/_loan/PreCibilQualification";

const PreCibilScoreQualification = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const cart_id = searchParams.get("cart_id");
  return (
    <Page title="Cbil Dashboard">
      <section id="contact_supplier" className="ptb-50">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
              {/* <div className="text-start mb-4">
                <Link
                  // to={`/pre-qualification-financial?loanId=${searchParams.get(
                  //   "loanId"
                  // )}`}
                  to={
                    cart_id !== null && cart_id !== undefined && cart_id !== ""
                      ? `/pre-qualification-financial?cart_id=${cart_id}&loanId=${searchParams.get(
                          "loanId"
                        )}`
                      : `/pre-qualification-financial?loanId=${searchParams.get(
                          "loanId"
                        )}`
                  }
                  className="btn btn-primary"
                >
                  <i className="fas fa-arrow-alt-circle-left"></i> Back
                </Link>
              </div> */}
              <PreCibilQualification />
            </div>
          </div>
        </div>
      </section>
    </Page>
  );
};

export default PreCibilScoreQualification;
